import { createProvider } from './vue-apollo';

const apolloProvider = createProvider();

export default apolloProvider;
